define('ordersDetailOrderProductStockListView',[
  'module',
  'backbone',
  'underscore',
  'app',
  'moment',
  'ordersDetailOrderProductStockListIconView',
  'tableView',
  'settings',
  'dateUtils'
], function (
    Module,
    Backbone,
    _,
    App,
    moment,
    IconView,
    TableView,
    Settings,
    DateUtil
) {
  'use strict';

  Module.exports = TableView.extend({

    className: 'orders-detail-order-product-stock-list-view table-view',
    pageSize: 20,

    setFields: function() {
      return [{
        name: 'icon',
        className: 'icon',
        view: IconView
      },{
        name: 'owner',
        label: _.i18n('offerList.productOwner'),
        className: 'owner',
        onRender: _.bind(function(view) {
          view.$el.html(view.model.get('productOwner') ? view.model.get('productOwner') : '-');
        }, this)
      }, {
        name: 'code',
        label: _.i18n('common.code'),
        className: 'code',
        onRender: function(view) {
          view.$el.html(view.model.get('code') ? $.trim(view.model.get('code')) : '-');
        }
      }, {
        name: 'options',
        label: _.i18n('common.options'),
        className: 'options',
        onRender: function(view) {
          view.$el.html(view.model.get('productOptions') ? $.trim(view.model.get('productOptions')) : '-');
        }
      }, {
        name: 'currentqty',
        label: _.i18n('product.stock.currentqty'),
        className: 'currentqty',
        onRender: function(view) {
          view.$el.html(view.model.get('currentQuantity') ? view.model.get('currentQuantity') : '-');
        }
      }, {
        name: 'nextdate',
        label: _.i18n('product.stock.nextdate'),
        className: 'nextdate',
        onRender: function(view) {
          view.$el.html(view.model.get('newArrivalETA') ? view.model.get('newArrivalETA') : '-');
        }
      }, {
        name: 'nextqty',
        label: _.i18n('product.stock.nextqty'),
        className: 'nextqty',
        onRender: function(view) {
          view.$el.html(view.model.get('newArrivalQuantity') ? view.model.get('newArrivalQuantity') : '-');
        }
      }];
    },

    fetch: function(first, pageSize) {
      var defer = $.Deferred();

      var stockList = [];
      var stockData = {};
      this.fetchStock().then(_.bind(function(stocks) {
        this.computeStock(stockData, stocks, this.options.productCode);
        _.each(stockData.stock, function (item) {
          var stock = {};

          stock.code = item.code;
          stock.lastUpdate = moment(new Date()).diff(moment(item.modDate), 'hours');

          if (stock.lastUpdate === 0)
            stock.lastUpdateMinutes = moment(new Date()).diff(moment(item.modDate), 'minutes');

          stock.upToDate = stock.lastUpdate < 4;
          stock.productOptions = '-';
          stock.currentQuantity = '-';
          stock.newArrivalETA = '-';
          stock.newArrivalQuantity = '-';

          stock.selected = item.code === this.options.productCode;
          stock.productOwner = this.options.productOwner;
          if ((this.options.productOwner !== this.options.caccountName)||
              (typeof this.options.productOwner === 'undefined' ||
                  typeof this.options.caccountName === 'undefined')) {
            stock.productOptions = item.productOptions;
            stock.currentQuantity = item.currentQuantity;
            stock.newArrivalETA = item.newArrivalETA;
            stock.newArrivalQuantity = item.newArrivalQuantity;
          }

          //if ((item.noStockInfo !== true && (item.currentQuantity > 0 || stock.newArrivalQuantity > 0)))
          stockList.push(stock);

        }, this);

        if (stockList.length === 0) {
          var stock = {};

          stock.code = this.options.productCode;
          stock.productOptions = '-';
          stock.currentQuantity = '-';
          stock.newArrivalETA = '-';
          stock.newArrivalQuantity = '-';
          stockList.push(stock);
        }

        var models = [];

        var list = stockList.slice(first, first + pageSize);

        _.each(list, _.bind(function(item) {
          var model = new Backbone.Model(item);
          models.push(model);
        }, this));

        defer.resolve(models);
      }, this)).fail(_.bind(function() {        
        defer.resolve([]);
      }, this));

      return defer.promise();
    }, 

    fetchStock: function() {
      var defer = $.Deferred(), url;

      if (this.options.pim)
        url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + this.options.secId + '/stocks');
      else
        url = Settings.url('compuzz2', 'products.json/' + this.options.secId + '/stocks');
      
      $.ajax({
        type: 'GET',
        url: url,
        success: function (data) {
          defer.resolve(data);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    computeStock: function(templateData, stocks, productCode) {
      templateData.outOfStock = false;
      if (stocks) {
        templateData.stock = stocks ;
        var that = this,
            moveStartIndex = -1,
            moveEndIndex = -1;

        _.each(templateData.stock, function (st, index) {
          if (st.newArrivalETA) {
            st.newArrivalETA = DateUtil.toDateFormatString(st.newArrivalETA);
          }
          if (st.code === productCode) {
            if (moveStartIndex === -1) {
              moveStartIndex = index;
            } else if (moveEndIndex === -1) {
              moveEndIndex = index;
            }
            if (templateData.quantity > st.currentQuantity && moveEndIndex === -1) {
              templateData.outOfStock = true;
            } else if (moveEndIndex === -1) {
              templateData.outOfStock = false;
            }
          }
          that.stockLineNumber++;
        });

        if (moveStartIndex !== -1) {
          if (moveEndIndex === -1) {
            moveEndIndex = moveStartIndex;
          }
          var currentProductOptions = templateData.stock.slice(moveStartIndex, moveEndIndex + 1);
          templateData.stock.splice(moveStartIndex, moveEndIndex - moveStartIndex + 1);
          templateData.stock = currentProductOptions.concat(templateData.stock);
        }
      }

    }
  });
});

